import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Hero.module.css';
// Import the SVG directly as a module
import charactersImage from '../../assets/characters.svg';

const Hero = () => {
  return (
    <section className={styles.heroContainer}>
      <div className={styles.contentWrapper}>
        <div className={styles.textContent}>
          <h1 className={styles.title}>
            The most advanced<br />
            AI therapist
          </h1>
          <p className={styles.subtitle}>
            Listens like a friend, coaches like a therapist.
          </p>
          <div className={styles.storeButtons}>
            <a href="https://play.google.com/store/apps/details?id=com.orangutan.aitherapist" target='_blank' rel='noreferrer' className={styles.storeButton} >
              <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Get it on Google Play"
                className={styles.googlePlayImage}
              />
            </a>

          </div>
        </div>
        <div className={styles.imageContent}>
          <img src={charactersImage} alt="AI Therapy Illustration" />
        </div>
      </div>

      <div className={styles.decorativeCircles}>
        <div className={`${styles.circle} ${styles.circle1}`}></div>
        <div className={`${styles.circle} ${styles.circle2}`}></div>
        <div className={`${styles.circle} ${styles.circle3}`}></div>
        <div className={`${styles.circle} ${styles.circle4}`}></div>
      </div>
    </section>
  );
};

export default Hero; 